import type { DocumentAttributeWireCandidate } from "~/shared/documents/schemas/document-attribute-wiring.schema";

import { Radio, Stack } from "~/ui";

type DocumentAttributePrefillCandidatePickerProps = {
  label: string;
  candidates: DocumentAttributeWireCandidate[];
  value: string;
  onSelect: (value: string) => void;
};

/** Create-modal picker when multiple wired product attributes supply values for one field. */
export const DocumentAttributePrefillCandidatePicker = ({
  label,
  candidates,
  value,
  onSelect,
}: DocumentAttributePrefillCandidatePickerProps) => {
  const selectedAttributeId = candidates.find(candidate => candidate.value === value)?.attributeId ?? "";

  return (
    <Stack spacing="xs">
      <Radio.Group
        label={label}
        value={selectedAttributeId}
        onChange={attributeId => {
          const candidate = candidates.find(entry => entry.attributeId === attributeId);
          if (candidate) {
            onSelect(candidate.value);
          }
        }}
      >
        <Stack spacing="xs">
          {candidates.map(candidate => (
            <Radio key={candidate.attributeId} value={candidate.attributeId} label={`${candidate.attributeName}: ${candidate.value}`} />
          ))}
        </Stack>
      </Radio.Group>
    </Stack>
  );
};
